import { render, staticRenderFns } from "./MonthlyTable.vue?vue&type=template&id=90d2b84a&"
import script from "./MonthlyTable.vue?vue&type=script&lang=js&"
export * from "./MonthlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports